import * as React from 'react';
import { trpc } from '../../../services/trpc';

function useImportServicerLoansAsAccountNotes(accountId: string) {
  const { mutateAsync } = trpc.importServicerLoansAsAccountNotes.useMutation();

  return React.useCallback(
    (servicerLoanIds: string[]) => mutateAsync({ accountId, servicerLoanIds }),
    [accountId, mutateAsync]
  );
}

export default useImportServicerLoansAsAccountNotes;
